var _react_refresh_temp_1;
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const ExperimentalFeature = ({ children }) => process.env.EXPERIMENTAL_UI_FEATURES === 'true' ? _jsx(_Fragment, { children: children }) : null;
_react_refresh_temp_1 = ExperimentalFeature;
$RefreshReg$(_react_refresh_temp_1, "ExperimentalFeature");
